 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		39: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		39: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "app." + ({"8":"app-components-Workflow-WorkflowContainer","9":"app-components-bibs-BibPage-BibPageContainer","10":"app-components-bibs-subpages-AllCommentsPage-AllCommentsPageContainer","11":"app-components-bibs-subpages-AllListsPage-AllListsPageContainer","12":"app-components-bibs-subpages-AllQuotationsPage-AllQuotationsPageContainer","13":"app-components-bibs-subpages-AllRecommendationsPage-AllRecommendationsPageContainer","14":"app-components-bibs-subpages-AllReviewsPage-AllReviewsPageContainer","15":"app-components-bibs-subpages-AllSummariesPage-AllSummariesPageContainer","16":"app-components-bibs-subpages-AllVideosPage-AllVideosPageContainer","17":"app-components-bibs-subpages-CommentPage-CommentPageContainer","18":"app-components-bibs-subpages-MarcPage-MarcPageContainer","19":"app-components-bibs-subpages-QuotationPage-QuotationPageContainer","20":"app-components-bibs-subpages-SummaryPage-SummaryPageContainer","21":"app-components-bibs-subpages-VideoPage-VideoPageContainer","22":"app-components-borrowing-accountmessages-AccountMessages-AccountMessagesContainer","23":"app-components-borrowing-checkouts-CheckedOut-CheckedOutContainer","24":"app-components-borrowing-checkouts-CheckedOutPrintList-CheckedOutPrintListContainer","25":"app-components-borrowing-fines-Fines-FinesContainer","26":"app-components-borrowing-holds-Holds-HoldsContainer","27":"app-components-borrowing-holds-HoldsPrintList-HoldsPrintListContainer","28":"app-components-borrowing-interlibraryLoans-InterlibraryLoans-InterlibraryLoansContainer","29":"app-components-borrowing-interlibraryLoans-InterlibraryLoansPrintList-InterlibraryLoansPrintListContainer","30":"app-components-borrowing-recentlyreturned-RecentlyReturned-RecentlyReturnedContainer","31":"app-components-borrowing-recentlyreturned-RecentlyReturnedPrintList-RecentlyReturnedPrintListContainer","32":"app-components-events-EventsSearchPage-EventsSearchPageContainer","33":"app-components-search-Search-SearchContainer","34":"app-components-search-SearchPrintList-SearchPrintListContainer","35":"app-components-shared-AvailabilityDetailOverlay-AvailabilityDetailOverlayContainer","36":"app-components-shelves-Shelf-ShelfContainer","37":"app-components-shelves-ShelfPrintList-ShelfPrintListContainer","38":"app-components-widgets-WidgetsPage-WidgetsPageContainer"}[chunkId]||chunkId) + "-" + {"0":"2a10d86f939360f88ed9","1":"9595e438d4c52af1c13b","2":"c0ec36999debf013b7bd","3":"99e5dfff925e643d8b40","4":"8c1a30495255dc4ff854","5":"31d579462aa127f76740","6":"9883270aae8de0cb7822","7":"fa26c8578ac9ef76cf0f","8":"037fb96368bff0e3042b","9":"04b1f108eae35f89f6e7","10":"92b809da38bed057039e","11":"5a264b31ae33f868478d","12":"9ceb084a896f8496d1fa","13":"e905bed1f0ffadc0bbf2","14":"49373084661950e3cb48","15":"8246d3cf71b1b1cac936","16":"449713329b238c4bfe59","17":"6ab575e4ea99b3b946b2","18":"c603cbdbea44d7737335","19":"372158b7c28d2a95b07f","20":"c3bf1d90c2eac90ec5e6","21":"95794cb533d119ddee38","22":"d4fc49503917a462a76f","23":"1ba92d5263b435412d4d","24":"ec701a508f5b901e18dd","25":"b6cd6b1b2e5f7b2b82b7","26":"1fcef35f6f461612e805","27":"6466d26767d13a66a36b","28":"edb66497808805d1d267","29":"f81e036d4035772e8e2d","30":"a9b28d1178c9d4de06c7","31":"4742e46ea2a375adb328","32":"55eaa73d9a16257d0995","33":"d80589976ec8e32a50b0","34":"5338b524a38ed719f4fe","35":"6f6a717d08816111798d","36":"36dfacd2a5300a033805","37":"2f70e8fc4384493eee8e","38":"4728bd21fca0fa1a23d1","41":"a6d63b9b254770fa79d7","42":"8d0b3490d5a3f901438b","43":"7e05cc2a8fd55570fd32","44":"d417ef91639d790c322c","45":"5e144730edf1a988e549","46":"dd90bb5f7923cedd5bce","47":"dc5d82a14fb02535b53a","48":"4e6e92bbe9c4a4879bc1","49":"22f8fc4445b16247dc79"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"1":1,"2":1,"3":1,"4":1,"5":1,"6":1,"7":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"26":1,"27":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"35":1,"36":1,"37":1,"38":1,"41":1,"42":1,"43":1,"44":1,"45":1,"46":1,"47":1,"48":1,"49":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "app." + ({"8":"app-components-Workflow-WorkflowContainer","9":"app-components-bibs-BibPage-BibPageContainer","10":"app-components-bibs-subpages-AllCommentsPage-AllCommentsPageContainer","11":"app-components-bibs-subpages-AllListsPage-AllListsPageContainer","12":"app-components-bibs-subpages-AllQuotationsPage-AllQuotationsPageContainer","13":"app-components-bibs-subpages-AllRecommendationsPage-AllRecommendationsPageContainer","14":"app-components-bibs-subpages-AllReviewsPage-AllReviewsPageContainer","15":"app-components-bibs-subpages-AllSummariesPage-AllSummariesPageContainer","16":"app-components-bibs-subpages-AllVideosPage-AllVideosPageContainer","17":"app-components-bibs-subpages-CommentPage-CommentPageContainer","18":"app-components-bibs-subpages-MarcPage-MarcPageContainer","19":"app-components-bibs-subpages-QuotationPage-QuotationPageContainer","20":"app-components-bibs-subpages-SummaryPage-SummaryPageContainer","21":"app-components-bibs-subpages-VideoPage-VideoPageContainer","22":"app-components-borrowing-accountmessages-AccountMessages-AccountMessagesContainer","23":"app-components-borrowing-checkouts-CheckedOut-CheckedOutContainer","24":"app-components-borrowing-checkouts-CheckedOutPrintList-CheckedOutPrintListContainer","25":"app-components-borrowing-fines-Fines-FinesContainer","26":"app-components-borrowing-holds-Holds-HoldsContainer","27":"app-components-borrowing-holds-HoldsPrintList-HoldsPrintListContainer","28":"app-components-borrowing-interlibraryLoans-InterlibraryLoans-InterlibraryLoansContainer","29":"app-components-borrowing-interlibraryLoans-InterlibraryLoansPrintList-InterlibraryLoansPrintListContainer","30":"app-components-borrowing-recentlyreturned-RecentlyReturned-RecentlyReturnedContainer","31":"app-components-borrowing-recentlyreturned-RecentlyReturnedPrintList-RecentlyReturnedPrintListContainer","32":"app-components-events-EventsSearchPage-EventsSearchPageContainer","33":"app-components-search-Search-SearchContainer","34":"app-components-search-SearchPrintList-SearchPrintListContainer","35":"app-components-shared-AvailabilityDetailOverlay-AvailabilityDetailOverlayContainer","36":"app-components-shelves-Shelf-ShelfContainer","37":"app-components-shelves-ShelfPrintList-ShelfPrintListContainer","38":"app-components-widgets-WidgetsPage-WidgetsPageContainer"}[chunkId]||chunkId) + "-" + {"0":"2a10d86f939360f88ed9","1":"9595e438d4c52af1c13b","2":"c0ec36999debf013b7bd","3":"99e5dfff925e643d8b40","4":"8c1a30495255dc4ff854","5":"31d579462aa127f76740","6":"9883270aae8de0cb7822","7":"fa26c8578ac9ef76cf0f","8":"037fb96368bff0e3042b","9":"04b1f108eae35f89f6e7","10":"92b809da38bed057039e","11":"5a264b31ae33f868478d","12":"9ceb084a896f8496d1fa","13":"e905bed1f0ffadc0bbf2","14":"49373084661950e3cb48","15":"8246d3cf71b1b1cac936","16":"449713329b238c4bfe59","17":"6ab575e4ea99b3b946b2","18":"c603cbdbea44d7737335","19":"372158b7c28d2a95b07f","20":"c3bf1d90c2eac90ec5e6","21":"95794cb533d119ddee38","22":"d4fc49503917a462a76f","23":"1ba92d5263b435412d4d","24":"ec701a508f5b901e18dd","25":"b6cd6b1b2e5f7b2b82b7","26":"1fcef35f6f461612e805","27":"6466d26767d13a66a36b","28":"edb66497808805d1d267","29":"f81e036d4035772e8e2d","30":"a9b28d1178c9d4de06c7","31":"4742e46ea2a375adb328","32":"55eaa73d9a16257d0995","33":"d80589976ec8e32a50b0","34":"5338b524a38ed719f4fe","35":"6f6a717d08816111798d","36":"36dfacd2a5300a033805","37":"2f70e8fc4384493eee8e","38":"4728bd21fca0fa1a23d1","41":"a6d63b9b254770fa79d7","42":"8d0b3490d5a3f901438b","43":"7e05cc2a8fd55570fd32","44":"d417ef91639d790c322c","45":"5e144730edf1a988e549","46":"dd90bb5f7923cedd5bce","47":"dc5d82a14fb02535b53a","48":"4e6e92bbe9c4a4879bc1","49":"22f8fc4445b16247dc79"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn-nerf.bibliocommons.com/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 2242);
